import styled from 'styled-components'

export const StyledRoot = styled.div`
		position: relative;
		z-index: 10;
		button {
			display: flex;
		}
`

export const StyledActions = styled.div`
		position: absolute;
		background: #eee;
		// top: -5px;
		right: 0;
		width: 300px;
		margin-top: 6px;
		box-shadow: 0 2px 4px 0 rgba(90, 90, 90, 0.2);
`

export const StyledActionLabel = styled.div`
		display: flex;
		align-items: center;
		width: ${({ nested }) => nested ? '80%' : '100%'};
		height: ${({ nested }) => nested ? '48px' : '64px'};
		padding: 0 20px;
		background: #fff;
		box-shadow: inset rgba(90, 90, 90, 0.2) 0px 2px 2px 0px;
		
		svg {
			// width: 20px;
			// height: 20px;
			margin-right: 10px;
		}
		${({ theme, isAvailable }) => !isAvailable ? `
			cursor: not-allowed;
			background: ${theme.inactiveColor};
			&:hover {
				background: ${theme.inactiveColor};
			}
		` : `
			cursor: pointer;
			&:hover {
				background: rgba(90, 90, 90, 0.05);
			}`}

		${({ iconStyles }) => iconStyles && `
			svg {
				${iconStyles}
			}
		`}

		${({ additionalStyles = '' })=>additionalStyles}
`
